export default {
  recordTitle: '充值記錄',
  detailTitle: '交易詳情',
  empty: '該篩選下暫無充值記錄',
  filterType: '充值類型',
  filterStatus: '充值狀態',
  filterTime: '充值時間',
  type: {
    all: '全部',
    ewallet: '數字錢包',
    crypto: '虛擬貨幣',
    alipay: '支付寶',
    wechat: '微信',
    bank: '銀行卡',
    unionpay: '雲閃付',
  },
  st: {
    all: '全部',
    paid: '已入賬',
    pending: '待支付',
    confirming: '確認中',
    expired: '已超時',
    cancelled: '已取消',
  },
  detailChannel: '充值渠道',
  detailNote: '說明',
  detailTime: '時間',
  detailId: '流水號',
  detailCurrency: '幣種賬戶',
  detailPayAmount: '支付金額',
  detailBonus: '加贈',
  detailRate: '鎖定匯率',
  detailNetwork: '網絡',
  detailAddress: '充值地址',
  detailConfirmations: '確認數',
  detailTxHash: '交易哈希',
  detailBankName: '收款銀行',
  detailAccountName: '收款戶名',
  detailAccountNumber: '收款卡號',
  detailMemo: '轉賬附言',
  detailExpireAt: '過期時間',
  detailTypeKey: '充值類型',
  contactSupport: '聯繫客服',
  rechargeRecord: '充值記錄',
  payment: '支付',
  exchangeRate: '匯率',
  confirmationsText: '{count} 確認',

  // Balance
  balanceLabel: '我的餘額',
  withdraw: '提現',

  // Marquee
  marqueeBanner: '🔊 新用戶首存好禮 · 每日首充有禮 · 虛擬幣首次入款加贈 · 點擊查看全部活動 ›',

  // Type / Channel labels
  typeCrypto: '虛擬貨幣',
  typeEwallet: '數字錢包',
  channelThirdParty: '(三方)',

  // Order Pending - typeChannel prop
  typeChannelCryptoOfficial: '虛擬貨幣 · USDT(官方)',
  typeChannelBankTransfer: '銀行卡 · 銀行卡轉賬',
  typeChannelDefault: '數字錢包',

  // Order Pending - paymentMethod prop
  paymentMethodOnchain: '虛擬貨幣 · 鏈上充值',
  paymentMethodBankPlatform: '銀行卡 · 銀行卡轉賬(平臺)',

  // Order Success
  walletNameCNY: 'CNY 錢包',
  walletNameUSDT: 'USDT 錢包',
  orderSuccessHint:
    '已發 DepositSucceeded(06 成長值 / 09 活動進度聯動)· 活動獎勵另計,請到獎勵中心領取',

  // Order Unfinished
  orderUnfinishedTitle: '該訂單未完成',
  orderUnfinishedSubtitle: '通道擁堵?已為你推薦成功率更高的渠道',
  retryCrypto: '換 USDT(官方) 重新下單',
  retryEwallet: '換 OKPAY 重新下單',

  // Tips
  tipsTitle: '溫馨提示',
  tip1: '到賬時間:法幣通道 1–5 分鐘;USDT 按網絡確認(TRC-20 約 1 分鐘)· 按實收金額入賬;',
  tip2: '請使用本人賬戶支付,金額須與訂單一致,請勿重複提交、修改金額或超時支付;',
  tip3: '跨幣種充值匯率<b>下單即鎖定</b>,訂單超時 / 取消後失效,需重新下單詢價;',
  tip4: '<b>渠道加贈與充值活動獎勵可疊加</b>:加贈隨充值直接入賬,活動獎勵請到「優惠 / 獎勵中心」領取;',
  tip5: '<b>三方渠道</b>(數字錢包/支付寶/微信/雲閃付)下單後跳轉外部收銀臺完成支付;<b>平臺自有渠道</b>(銀行卡轉賬 / USDT·ETH·BTC 官方鏈上)在本頁生成收款信息;',
  tip6: '充值未到賬請攜訂單號聯繫在線客服;維護中的渠道將自動隱藏。',

  // CTA Button
  ctaGetAccount: '獲取收款賬戶',
  ctaGenerateOrder: '生成充值訂單',
  ctaRecharge: '立即充值',

  // Embedded wallet deposit (VIPPAY 等 pay_flow=embedded)
  embeddedPhoneLabel: '錢包手機號',
  embeddedPhonePlaceholder: '請輸入錢包註冊手機號',
  embeddedPasswordLabel: '錢包安全密碼',
  embeddedPasswordPlaceholder: '請輸入錢包安全密碼',
  embeddedPasswordHint: '安全密碼僅用於本次劃轉，不會被保存或記錄',
  embeddedConfirming: '劃轉中…',
  embeddedSuccess: '劃轉成功，已入賬',
  embeddedErrPhone: '請輸入正確的 11 位手機號',
  embeddedErrPassword: '請輸入錢包安全密碼',
  embeddedErrAmount: '金額格式不合法',
  embeddedErrRange: '金額需在 {min} ~ {max} 之間',
  embeddedFailWarn:
    '劃轉失敗，上一筆結果可能未確認。請勿重複提交，否則可能被扣兩次；如有疑問請聯繫客服。',
  embeddedRestricted: '賬號已被限制充值，如有疑問請聯繫客服。',

  // Embedded wallet gate popups (VIPPAY 等)
  gatePhoneTitle: '使用 VIPPAY 前請先綁定手機號',
  gatePhoneDesc: '綁定後將直接使用該手機號登錄 VIPPAY，無需再次輸入賬號或密碼。',
  gatePhoneCta: '去綁定手機號',
  gateCancel: '取消',
  gateFundTitle: '本站賬號需先設置資金密碼',
  gateFundDesc:
    '使用本站綁定手機號快捷登錄，需要先在安全中心設置資金密碼；也可直接登錄其他 VIPPAY 賬號。',
  gateFundInfo: '本站賬號設置一次即可，確認支付時無需再次輸入資金密碼。',
  gateFundCta: '去設置資金密碼',
  gateFundManual: '+ 手動輸入其他賬號登錄',
  gateFundManualDesc: '其他賬號無需設置本站資金密碼；每次登錄仍需輸入該賬號的密碼。',

  // 圖2：選擇 VIPPAY 登錄賬號（綁定手機後 / 已設資金密碼）
  gateAccountTitle: '選擇 VIPPAY 登錄賬號',
  gateAccountDesc: '使用本站綁定賬號，或選擇曾登錄的其他賬號',
  gateAccountBound: '本站綁定手機號',
  gateAccountFree: '免輸入密碼',
  gateAccountManualDesc: '其他賬號每次需輸入密碼；原型僅記住手機號，不主動保存密碼。',
  gateAccountCta: '確認使用並繼續',
  // 圖3：登錄其他 VIPPAY 賬號
  gateManualBack: '返回選擇賬號',
  gateManualTitle: '登錄其他 VIPPAY 賬號',
  gateManualDesc: '輸入該賬號的手機號和密碼，本次充值使用此賬號支付。',
  gateManualPhoneLabel: 'VIPPAY 手機號',
  gateManualPhonePh: '請輸入 11 位手機號',
  gateManualPwdLabel: '登錄密碼',
  gateManualPwdPh: '請輸入該賬號密碼',
  gateManualHint: '原型僅模擬登錄，不校驗第三方真實密碼；不會主動保存密碼。',
  gateManualCta: '登錄並繼續',

  // 最近使用的其他賬號
  gateRecentTitle: '最近使用的其他賬號',
  gateRecentLogin: '輸入密碼登錄',

  // 圖1：VIPPAY 安全支付頁（其他賬號）
  gatePayTitle: 'VIPPAY',
  gatePayHeading: 'VIPPAY 安全支付',
  gatePaySub: '已使用其他 VIPPAY 賬號登錄',
  gatePaySubSystem: '使用本站綁定手機號快捷登錄',
  gatePayOtherAccount: '其他賬號',
  gatePaySystemAccount: '本站賬號',
  gatePayLockedTag: '本單已鎖定',
  gatePayAmountLabel: '本次支付金額',
  gatePayOrderLabel: '商戶訂單',
  gatePayArriveLabel: '預計到賬',
  gatePayLockHint: '本單支付賬號已鎖定；如需切換,請返回並取消訂單後重新選擇',
  gatePayCta: '確認支付',
  gatePayDoing: '確認中…',
  gatePayFooter: '支付信息由 VIPPAY 加密處理，支付結果以商戶到賬通知為準。',

  // Amount text (with interpolation)
  arrivedApprox: '到賬約 {amount}',
  arrivedWithBonus: '到賬約 {amount},含加贈 {bonus}',

  // Rate text
  rateCnyToUsdt: '1 CNY ≈ {rate} USDT',
  rateCryptoToUsdt: '1 {currency} ≈ {rate} USDT',
  rateCryptoToCny: '1 {currency} ≈ ¥{rate}',

  // Mock bank data
  bankName: '招商銀行',
  accountName: '王*成',
  confirmCount: '{count} 個確認',
  cryptoNote: '按實收金額入賬 · 請勿向該地址轉入其他幣種 · {count} 個確認 ≈ 1 分鐘(docs 03 形態③)',

  // RechargeForm - Section titles
  rechargeType: '充值類型',
  rechargeChannel: '充值渠道',
  channelWindow: '每日可用時段 {window}',
  rechargeAmount: '充值金額',

  // RechargeForm - Labels & placeholders
  depositLabel: '存款金額',
  enterAmountPlaceholder: '請輸入充值金額',
  selectChannelFirst: '請選擇充值渠道',

  // RechargeForm - Range text (with interpolation)
  rangeFmtCrypto: '可充值區間 {min} {currency} – {max} {currency}({name})',
  rangeFmtFiat: '可充值區間 ¥{min} – ¥{max}({name})',

  // RechargeForm - Error messages
  minRechargeError: '最低充值金額 ¥{min}',
  maxRechargeError: '最高充值金額 ¥{max}',

  // RechargeForm - Get amount label
  getAmountWithBonus: '💰 獲得金額(含渠道加贈 {bonus})',
  getAmountNoBonus: '💰 獲得金額(入賬至當前錢包)',

  // RechargeForm - Rate text
  rateReference: '參考匯率 {from} ≈ {to} · 下單後鎖定本單匯率,訂單關閉即失效',

  // Recharge type labels (keyed by type key)
  typeLabel_ewallet_name: '數字錢包',
  typeLabel_ewallet_subtitle: '筆筆加贈',
  typeLabel_ewallet_tag: '推薦',
  typeLabel_crypto_name: '虛擬貨幣',
  typeLabel_crypto_subtitle: '鏈上直充',
  typeLabel_crypto_tag: '安全',
  typeLabel_alipay_name: '支付寶',
  typeLabel_alipay_subtitle: '一鍵支付',
  typeLabel_alipay_tag: '極速',
  typeLabel_wechat_name: '微信',
  typeLabel_wechat_subtitle: '方便快捷',
  typeLabel_wechat_tag: '穩定',
  typeLabel_bank_name: '銀行卡',
  typeLabel_bank_subtitle: '大額轉賬',
  typeLabel_bank_tag: '穩定',
  typeLabel_unionpay_name: '雲閃付',
  typeLabel_unionpay_subtitle: '銀聯掃碼',
  typeLabel_unionpay_tag: '穩定',

  // Channel names (keyed by channel id, Chinese-named channels only)
  channelName_4: '波幣',
  channelName_5: 'NO錢包',
  channelName_7: '萬幣',
  channelName_9: 'K豆',
  channelName_11: '808錢包',
  channelName_12: '365錢包',
  channelName_13: 'HD錢包',
  channelName_14: 'C幣錢包',
  channelName_15: 'SPAY錢包',
  channelName_16: 'TGPAY錢包',
  channelName_101: 'USDT(官方)',
  channelName_102: 'USDT掃碼',
  channelName_103: 'USDT轉賬',
  channelName_104: 'USDT大額',
  channelName_105: 'USDT小額',
  channelName_106: 'ETH掃碼',
  channelName_107: 'ETH大額',
  channelName_108: 'BTC掃碼',
  channelName_109: 'BTC大額',
  channelName_201: '小額支付寶1',
  channelName_202: '小額支付寶2',
  channelName_203: '支付寶掃碼',
  channelName_204: '大額支付寶',
  channelName_205: '支付寶金條',
  channelName_301: '小額微信1',
  channelName_302: '小額微信2',
  channelName_303: '微信掃碼',
  channelName_304: '大額微信',
  channelName_401: '銀行卡轉賬',
  channelName_501: '雲閃付掃碼',
  channelName_502: '雲閃付轉卡',

  // Channel iconText (keyed by iconKey, shared keys for same icon)
  channelIcon_1: 'VIP',
  channelIcon_2: 'GO',
  channelIcon_3: 'OK',
  channelIcon_4: '波',
  channelIcon_5: 'NO',
  channelIcon_6: 'TO',
  channelIcon_7: '萬',
  channelIcon_8: 'U',
  channelIcon_9: 'K豆',
  channelIcon_10: 'JJ',
  channelIcon_808: '808',
  channelIcon_365: '365',
  channelIcon_HD: 'HD',
  channelIcon_alipay: '支',
  channelIcon_wechat: '微',
  channelIcon_bank: '銀',
  channelIcon_unionpay: '閃',

  // OrderPending - Titles & labels
  orderPendingTitle: '訂單待支付',
  orderIdLabel: '單號',
  amountLabel: '支付金額',
  typeChannelLabel: '類型 · 通道',
  paymentMethodLabel: '支付方式',
  lockedRateLabel: '匯率鎖定',
  remainingTimeLabel: '剩餘支付時間',

  // OrderPending - Bank info labels
  bankNameLabel: '收款銀行',
  accountNameLabel: '收款戶名',
  cardNumberLabel: '收款卡號',
  transferAmountLabel: '轉賬金額(含識別尾數)',
  transferRemarkLabel: '轉賬附言(必填)',

  // OrderPending - Crypto info labels
  networkLabel: '網絡',
  depositAddressLabel: '充值地址',
  confirmCountLabel: '確認數',

  // OrderPending - Buttons & actions
  copyBtn: '複製',
  waitingConfirming: '等待入賬確認',
  doneTransfer: '我已完成轉賬',
  donePayment: '我已完成支付',
  cancelOrder: '取消訂單',
  reopenPayment: '重新打開支付頁',
  reopenVippay: '打開 VIPPAY',
  orderCancelled: '訂單已取消',
  orderPaid: '訂單已入賬',
  orderExpired: '訂單已超時',
  orderTransferredSuccess: '已確認轉賬,等待入賬',
  orderTransferredFailed: '操作失敗,請重試',
  orderCannotBeCancelled: '該訂單支付已確認不可關閉',

  // OrderSuccess - Labels & text
  orderSuccessTitle: '充值成功',
  orderCredited: '已到賬',
  creditedAmountLabel: '入賬金額',
  creditedWalletLabel: '入賬錢包',
  doneBtn: '完成',

  // OrderPending - Notes / hints
  bankNote:
    '請使用本人銀行卡按「含識別尾數金額」足額轉賬並填寫附言 8866(雙保險自動核銷,docs 03 形態②)',
  thirdPartyNote: '已在新窗口打開三方收銀臺,支付完成後回本頁等待入賬;未彈出?',

  // WithdrawForm - Titles & labels
  withdrawRecords: '提現記錄',
  withdrawAmountLabel: '提現金額',
  withdrawablePrefix: '可提現',
  withdrawTo: '提現到',
  selectWithdrawAccount: '請選擇提現賬戶',
  accountTypeHint: '數字錢包 / 加密貨幣 / 銀行卡 / 支付寶',
  changeAccount: '更換',
  allBtn: '全部',

  // WithdrawForm - Fee card
  feeLabel: '手續費',
  feeLabelRate: '手續費({rate}%)',
  feeFree: '免費',
  estimatedArrival: '預計到賬',
  refRate: '參考匯率',
  choosePayoutHint: '選擇到賬方式後,計算手續費與到賬',

  // WithdrawForm - Hints
  withdrawHintTop: '最快 5-10 分鐘到賬 · 單筆最低',
  withdrawMinUsdt: '20 USDT',
  withdrawMinCny: '¥100',
  withdrawHintBottom: '請仔細核對收款信息,轉入他人賬戶將無法追回',

  // WithdrawForm - Button & errors
  confirmWithdraw: '確認提現',
  selectAccountFirst: '請選擇提現賬戶',
  errEnterWithdrawAmount: '請輸入提現金額',
  errWithdrawBelowMin: '單筆最低提現 {amount}',
  errSelectWithdrawAccount: '請選擇提現賬戶',
  errNeedKyc: '該賬戶需完成實名認證後方可提現',
  // 金額校驗聯動：行內紅字 / 按鈕態 / 超額 toast
  withdrawBelowMinGap: '還差 {amount} 起提',
  withdrawMinOnly: '單筆最低 {amount}',
  withdrawOverBalance: '超出可提現金額',
  errWithdrawOverBalance: '可提現金額不足，當前最多可提 {amount}',

  // WithdrawForm - Account display prefixes
  accountPrefixEwallet: '數字錢包',
  accountPrefixCrypto: '加密貨幣',
  accountPrefixBank: '銀行卡',
  accountPrefixAlipay: '支付寶',

  // WithdrawResult - Titles & text
  withdrawResultTitle: '提現結果',
  withdrawSubmitted: '提現申請已提交',
  withdrawArrivingSoon: '⚡ 預計 5-10 分鐘到賬',
  accountCreditedLabel: '到賬賬戶',
  statusLabel: '當前狀態',
  statusProcessing: '處理中',
  estimatedArrivalTime: '預計到賬',
  arrivalInTime: '· 5-10 分鐘內',
  flowIdLabel: '流水號',
  viewWithdrawRecords: '查看提現記錄',

  // KYC - Title & guide
  kycTitle: '實名認證',
  kycGuideTitle: '🛡 為什麼需要實名認證?',
  kycGuide1: '· 應監管與反洗錢(AML)要求,平臺須核驗用戶真實身份',
  kycGuide2: '· 保障賬戶與資金安全:<b>提現收款賬戶須與實名一致</b>',
  kycGuide3: '· 信息加密存儲,僅用於合規核驗,不作任何其他用途',

  // KYC - Labels & placeholders
  kycDocumentType: '證件類型',
  kycIdCard: '居民身份證',
  kycPassport: '護照',
  kycRealName: '真實姓名',
  kycRealNamePlaceholder: '與證件姓名一致(2–20 位中文)',
  kycIdNumber: '身份證號碼',
  kycPassportNumber: '護照號碼',
  kycIdNumberPlaceholder: '18 位身份證號(末位可為 X)',
  kycPassportPlaceholder: '8-9 位護照號碼',
  kycExpiryDate: '證件有效期',
  kycExpiryPlaceholder: '2030-12-31',
  kycLongTerm: '長期有效',
  kycDocumentPhotos: '證件照片',

  // KYC - Photo tiles
  kycIdPortrait: '身份證 · 人像面',
  kycIdEmblem: '身份證 · 國徽面',
  kycPassportData: '護照 · 資料頁',
  kycSelfie: '手持證件照',
  kycUploadHint: '拍攝或從相冊上傳',
  kycReupload: '重新上傳',
  kycUploading: '上傳中…',

  // KYC - Requirements & agreement
  kycPhotoRequirement:
    '要求:證件邊框完整 · 字跡清晰 · 無反光遮擋 · 單張 ≤ 5MB;手持照需本人面部與證件信息同框清晰',
  kycAgreeText:
    '我已閱讀並同意<a href="#" class="link-inline" data-nav="privacy">《隱私政策》</a>,授權平臺將以上信息用於身份核驗',

  // KYC - Submit button
  kycSubmit: '提交認證',
  kycSubmitting: '提交中…',
  kycDemoTag: '原型模擬',
  kycDemoBar: '賬戶已下發 kycRequired',
  kycDemoFill: '填入演示資料',
  kycDemoFilled: '已填入模擬認證資料',

  // KYC - Processing state
  kycProcessingTitle: '實名信息審核中',
  kycProcessingDesc: '預計 1–3 分鐘完成(OCR 識別 + 人工復核兜底)',
  kycProcessingDesc2: '審核通過將自動通知,並自動繼續本次提現',
  kycProcessingNotify: '審核通過將自動通知',
  kycSubmitted: '已提交,進入審核(OCR + 人工兜底)',

  // KYC - 提現頁狀態卡片
  kycCardTitle: '賬戶安全認證',
  kycCardDesc: '該賬戶提現前需完成實名認證',
  kycGoVerify: '去認證',
  kycVerifiedTag: '已認證',
  kycPendingTag: '審核中',
  kycRejectedTag: '未通過',

  // KYC - 駁回頁（/kyc/details rejected）
  kycRejectedTitle: '審核未通過',
  kycRejectedDesc: '請根據原因修正後重新提交,已填信息已為你保留',
  kycRejectedReason: '駁回原因:',
  kycResubmit: '重新提交',
  kycCardSubApproved: '已完成實名認證',
  kycCardSubPending: '認證資料審核中，預計 1–3 工作日',
  kycCardSubRejected: '認證未通過，請修改後重新提交',

  // KYC - 已認證詳情頁
  kycDetailTitle: '已完成實名認證',
  kycDetailDesc1: '實名信息已加密存儲並鎖定',
  kycDetailDesc2: '提現收款賬戶須與實名一致;如需變更請聯繫在線客服',
  kycDetailDocType: '證件類型',
  kycDetailRealName: '真實姓名',
  kycDetailIdNumber: '證件號碼',
  kycDetailExpiry: '證件有效期',

  // KYC - Processing card labels
  kycMaskedNameLabel: '真實姓名',
  kycMaskedNumberLabel: '證件號碼',
  kycMaskedIdTypeLabel: '證件類型',
  kycMaskedExpiryLabel: '證件有效期',

  // KYC - Error messages
  kycErrName: '姓名須為 2–20 位中文(可含「·」)',
  kycErrIdNumber: '身份證號碼不正確,請核對後重填',
  kycErrPassportNumber: '護照號應為 8–9 位字母或數字',
  kycErrExpiryInvalid: '請填寫證件有效期(如 2030-12-31)或勾選長期有效',
  kycErrExpiryExpired: '證件已過期,無法通過認證',
  kycErrUploadAllId: '請上傳全部證件照片(人像面、國徽面與手持證件照)',
  kycErrUploadAllPassport: '請上傳全部證件照片(資料頁與手持證件照)',
  kycErrAgree: '請閱讀並勾選《隱私政策》授權',
  kycErrFileType: '僅支持 JPG、PNG、WebP 格式的照片',
  kycErrFileSize: '照片不能超過 5MB,請重新選擇',
  kycErrUploading: '照片上傳失敗,請重新選擇',
  kycErrPhotoPending: '照片上傳中,請稍候再提交',
  kycErrRejected: '上次審核未通過,請修改資料後重新提交',
}
